import { useGetAccountPromosQuery } from "@apis/accounts/useAccounts"
import { groupAccountPromos } from "./utils/utils"
import { DataTable } from "@components/DataTable/DataTable"
import { existingPromosColumns } from "./utils/tableColumnSchema"

type TExistingPromosProps = {
  account_id: string
}

export const ExistingPromos = ({ account_id }: TExistingPromosProps) => {
  const {
    data = [],
    isPending,
    isError,
    error,
  } = useGetAccountPromosQuery(account_id)
  const groupedPromos = groupAccountPromos(data)

  if (isError) {
    return (
      <div className="tw:text-red-500">
        {`There was an error loading existing promos. Error: ${error?.message}`}
      </div>
    )
  }

  return (
    <div className="tw:rounded-lg tw:border tw:border-gray-200 tw:p-4">
      <h2 className="tw:text-xl">Existing Promos</h2>
      <DataTable
        columns={existingPromosColumns}
        data={groupedPromos}
        pending={isPending}
      />
    </div>
  )
}
